import { render } from "./import-offices-controls.vue?vue&type=template&id=a4b1f38c"
import script from "./import-offices-controls.vue?vue&type=script&lang=js"
export * from "./import-offices-controls.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__